module.exports = __webpack_public_path__ + "assets/img/media_11.b275af28.png";